export default __webpack_public_path__ + "static/media/cbc_logo_white.29d35146.svg";